import { render, staticRenderFns } from "./CurriculumVideo.vue?vue&type=template&id=40cbd318&"
import script from "./CurriculumVideo.vue?vue&type=script&lang=js&"
export * from "./CurriculumVideo.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports